import { TileCategory } from '../types';

export interface FriezeMix {
  id: string;
  /** Подпись для интерфейса */
  label: string;
  /** Порядок категорий плитки, повторяется по ряду фриза */
  cycle: TileCategory[];
}

/**
 * Комбинации фриза: полоса фриза собирается из стеновой плитки по кругу.
 * Порядок в массиве = порядок в выпадающем списке «Комбинация фриза»,
 * первый элемент — значение по умолчанию.
 */
export const FRIEZE_MIXES: FriezeMix[] = [
  { id: 'light2-dark1-light1', label: '2 светлые + 1 тёмная + 1 светлая', cycle: ['lightWall', 'lightWall', 'darkWall', 'lightWall'] },
  { id: 'light2-dark1', label: '2 светлые + 1 тёмная', cycle: ['lightWall', 'lightWall', 'darkWall'] },
  { id: 'light1-dark1', label: '1 светлая + 1 тёмная', cycle: ['lightWall', 'darkWall'] },
  { id: 'dark1-light1', label: '1 тёмная + 1 светлая', cycle: ['darkWall', 'lightWall'] },
  { id: 'dark2-light1', label: '2 тёмные + 1 светлая', cycle: ['darkWall', 'darkWall', 'lightWall'] },
];

export const DEFAULT_FRIEZE_MIX = FRIEZE_MIXES[0].id;

export const getFriezeMix = (id?: string): FriezeMix =>
  FRIEZE_MIXES.find((mix) => mix.id === id) ?? FRIEZE_MIXES[0];
